import { render, staticRenderFns } from "./ReferenceTypeDialog.vue?vue&type=template&id=0f4c974f"
import script from "./ReferenceTypeDialog.vue?vue&type=script&lang=js"
export * from "./ReferenceTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports